import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ScrollTriggerをGSAPに登録
gsap.registerPlugin(ScrollTrigger);

export function changeSectionBgColor02() {
  const sections = document.querySelectorAll(".js-bg-change");

  sections.forEach((section) => {
    // ScrollTriggerを作成
    ScrollTrigger.create({
      trigger: section,
      start: "top 65%", // セクションが表示されるタイミング
      end: "bottom center", // セクションが消えるまでトリガーが続く
      onEnter: () => {
        // トリガーされたセクションにis-changeクラスを追加
        section.classList.add("is-change");
      },
      onLeave: () => {
        // スクロールでセクションが表示領域を離れたらクラスを削除
        section.classList.remove("is-change");
      },
      onEnterBack: () => {
        // 戻ってきた場合もクラスを再追加
        section.classList.add("is-change");
      },
      onLeaveBack: () => {
        // 上方向にスクロールしてセクションが表示領域を離れたらクラスを削除
        section.classList.remove("is-change");
      },

      markers: false, // デバッグ用マーカーを無効に
    });
  });
}
